import hsrs from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/HSRs/HSRs";
import hsr from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/HSRs/HSR";

import tdms from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/TDMs/TDMs";
import tdm from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/TDMs/TDM";

import kadls from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/KADLs/KADLs";
import kadl from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/KADLs/KADL";

import agencies from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Agencies/Agencies";
import agency from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Agencies/Agency";

import networks from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Networks/Networks";
import network from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Networks/Network";

import externalformats from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/ExternalFormats/ExternalFormats";
import externalformat from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/ExternalFormats/ExternalFormat";

import outlettypes from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/OutletTypes/OutletTypes";
import outlettype from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/OutletTypes/OutletType";

import channels from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Channels/Channels";
import channel from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Channels/Channel";

import clusters from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Clusters/Clusters";
import cluster from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Clusters/Cluster";

import narkas from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/NARKAs/NARKAs";
import narka from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/NARKAs/NARKA";

import sipchannels from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/SIPChannels/SIPChannels";
import sipchannel from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/SIPChannels/SIPChannel";

import kass from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/KASs/KASs";
import kas from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/KASs/KAS";

import merchandisers from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Merchandisers/Merchandisers";
import merchandiser from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Merchandisers/Merchandiser";

import routecodes from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/RouteCodes/RouteCodes";
import routecode from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/RouteCodes/RouteCode";

import addressprogramorders from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/AddressProgramOrders/AddressProgramOrders";
import addressprogramorder from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/AddressProgramOrders/AddressProgramOrder";

import marsperiods from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/MarsPeriods/MarsPeriods";
import marsperiod from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/MarsPeriods/MarsPeriod";

import orders from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Orders/Orders";
import order from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Orders/Order";

import documents from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Documents/Documents";

import home from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Home/Home";

import adjustments from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Adjustments/Adjustments";
import adjustment from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Adjustments/Adjustment";

import areas from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Areas/Areas";
import area from "../../../../Services/AddressProgram/AddressProgram.Frontend/views/Areas/Area";

export const addressprogramRoutes = [
  {
    path: "/addressprogram/hsrs",
    name: "hsrs",
    component: hsrs,
  },
  {
    path: "/addressprogram/hsr/:id",
    name: "hsr",
    component: hsr,
    meta: {
      menuitem: "/addressprogram/hsrs",
    },
  },

  {
    path: "/addressprogram/tdms",
    name: "tdms",
    component: tdms,
  },
  {
    path: "/addressprogram/tdm/:id",
    name: "tdm",
    component: tdm,
    meta: {
      menuitem: "/addressprogram/tdms",
    },
  },

  {
    path: "/addressprogram/kadls",
    name: "kadls",
    component: kadls,
  },
  {
    path: "/addressprogram/kadl/:id",
    name: "kadl",
    component: kadl,
    meta: {
      menuitem: "/addressprogram/kadls",
    },
  },

  {
    path: "/addressprogram/agencies",
    name: "agencies",
    component: agencies,
  },
  {
    path: "/addressprogram/agency/:id",
    name: "agency",
    component: agency,
    meta: {
      menuitem: "/addressprogram/agencies",
    },
  },

  {
    path: "/addressprogram/networks",
    name: "networks",
    component: networks,
  },
  {
    path: "/addressprogram/network/:id",
    name: "network",
    component: network,
    meta: {
      menuitem: "/addressprogram/networks",
    },
  },

  {
    path: "/addressprogram/externalformats",
    name: "externalformats",
    component: externalformats,
  },
  {
    path: "/addressprogram/externalformat/:id",
    name: "externalformat",
    component: externalformat,
    meta: {
      menuitem: "/addressprogram/externalformats",
    },
  },

  {
    path: "/addressprogram/outlettypes",
    name: "outlettypes",
    component: outlettypes,
  },
  {
    path: "/addressprogram/outlettype/:id",
    name: "outlettype",
    component: outlettype,
    meta: {
      menuitem: "/addressprogram/outlettypes",
    },
  },

  {
    path: "/addressprogram/channels",
    name: "channels",
    component: channels,
  },
  {
    path: "/addressprogram/channel/:id",
    name: "channel",
    component: channel,
    meta: {
      menuitem: "/addressprogram/channels",
    },
  },

  {
    path: "/addressprogram/clusters",
    name: "clusters",
    component: clusters,
  },
  {
    path: "/addressprogram/cluster/:id",
    name: "cluster",
    component: cluster,
    meta: {
      menuitem: "/addressprogram/clusters",
    },
  },

  {
    path: "/addressprogram/narkas",
    name: "narkas",
    component: narkas,
  },
  {
    path: "/addressprogram/narka/:id",
    name: "narka",
    component: narka,
    meta: {
      menuitem: "/addressprogram/narkas",
    },
  },

  {
    path: "/addressprogram/sipchannels",
    name: "sipchannels",
    component: sipchannels,
  },
  {
    path: "/addressprogram/sipchannel/:id",
    name: "sipchannel",
    component: sipchannel,
    meta: {
      menuitem: "/addressprogram/sipchannels",
    },
  },

  {
    path: "/addressprogram/kass",
    name: "kass",
    component: kass,
  },
  {
    path: "/addressprogram/kas/:id",
    name: "kas",
    component: kas,
    meta: {
      menuitem: "/addressprogram/kass",
    },
  },

  {
    path: "/addressprogram/merchandisers",
    name: "merchandisers",
    component: merchandisers,
  },
  {
    path: "/addressprogram/merchandiser/:id",
    name: "merchandiser",
    component: merchandiser,
    meta: {
      menuitem: "/addressprogram/merchandisers",
    },
  },

  {
    path: "/addressprogram/routecodes",
    name: "routecodes",
    component: routecodes,
  },
  {
    path: "/addressprogram/routecode/:id",
    name: "routecode",
    component: routecode,
    meta: {
      menuitem: "/addressprogram/routecodes",
    },
  },

  {
    path: "/addressprogram/dashboard",
    name: "dashboard",
    component: home,
  },
  {
    path: "/addressprogram/addressprogramorders",
    name: "addressprogramorders",
    component: addressprogramorders,
  },
  {
    path: "/addressprogram/addressprogramorder/:id",
    name: "addressprogramorder",
    component: addressprogramorder,
    meta: {
      menuitem: "/addressprogram/addressprogramorders",
    },
  },
  {
    path: "/addressprogram/addressprogramorder/adjustmentmultiplecreate",
    name: "adjustmentmultiplecreate",
    component: addressprogramorder,
    meta: {
      menuitem: "/addressprogram/addressprogramorders",
    },
  },

  {
    path: "/addressprogram/marsperiods",
    name: "marsperiods",
    component: marsperiods,
  },
  {
    path: "/addressprogram/marsperiod/:id",
    name: "marsperiod",
    component: marsperiod,
    meta: {
      menuitem: "/addressprogram/marsperiods",
    },
  },

  {
    path: "/addressprogram/orders",
    name: "orders",
    component: orders,
  },
  {
    path: "/addressprogram/order/:id",
    name: "order",
    component: order,
    meta: {
      menuitem: "/addressprogram/orders",
    },
  },

  {
    path: "/addressprogram/documents",
    name: "documents",
    component: documents,
  },
  {
    path: "/addressprogram/document/:id",
    name: "document",
    component: document,
    meta: {
      menuitem: "/addressprogram/documents",
    },
  },

  {
    path: "/addressprogram/adjustments",
    name: "adjustments",
    component: adjustments,
  },

  {
    path: "/addressprogram/adjustment/:id",
    name: "adjustment",
    component: adjustment,
    meta: {
      menuitem: "/addressprogram/adjustments",
    },
  },

    {
    path: "/addressprogram/areas",
    name: "areas",
    component: areas,
  },
  {
    path: "/addressprogram/area/:id",
    name: "area",
    component: area,
    meta: {
      menuitem: "/addressprogram/areas",
    },
  },
];

export default addressprogramRoutes;
